import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import SurveysIndexPage from '@/pages/organizations/detail/surveys'

export const Route = createFileRoute('/app/organizations/$organizationId/surveys')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <SurveysIndexPage />
}
